import ClickAwayListener from '@mui/material/ClickAwayListener';
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProfilePic } from '../../helpers/images';
import { getNewNotification, getNotificationItems } from '../../helpers/users';
import LogoIcon from '../../images/icons/logo_icon.svg';
import { useGlobalContext } from '../../stores/global';
//import SignupToSellButton from '../SignupToSellButton';
import styles from './Footer.module.scss';

export default function Footer() {
  const { user, dispatch } = useGlobalContext();
  const [showMenu, setShowMenu] = useState(false);
  const centralLogoRef = useRef<HTMLButtonElement>(null);
  const { showNotification } = getNotificationItems(user);
  const [newNotificationView, setNewNotificationView] = useState<any>(false);
  const chatMessagesPollingIntervalRef = useRef<number>();

  // Polling notification

  const startNotificationPolling = () => {
    setNewNotificationView(getNewNotification().newNotification);
    window.clearInterval(chatMessagesPollingIntervalRef.current);
    chatMessagesPollingIntervalRef.current = window.setInterval(() => {
      setNewNotificationView(getNewNotification().newNotification);
      // }, 5000 * 100000); // TODO: enable polling again
    }, 5000);
  };

  useEffect(() => {
    startNotificationPolling();
    return () => {
      window.clearInterval(chatMessagesPollingIntervalRef.current);
    };
  }, []);

  return (
    <footer className={styles.container}>
      <div className={styles.buttons}>
        <Link to="/pricing">
          <i className="fonticons fonticons-credit-card" />
          <span>Precios</span>
        </Link>
        {/* <SignupToSellButton>
          <i className="fonticons fonticons-home2" />
          <span>Vender</span>
        </SignupToSellButton> */}
        <Link to="/properties">
          <i className="fonticons fonticons-alerts" />
          <span>Alertas</span>
        </Link>
        <Link
          to="/"
          /* ref={centralLogoRef} */
          className={styles.centralLogo}
          /* onClick={() => setShowMenu(!showMenu)} */
        >
          <img src={LogoIcon} />
        </Link>
        <Link to="/favorites">
          <i className="fonticons fonticons-heart" />
          <span>Favoritos</span>
        </Link>
        <Link
          to="/me"
          onClick={(e) => {
            if (!user) {
              e.preventDefault();
              dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' });
            }
          }}
        >
          {showNotification ||
            (newNotificationView && <div className={styles.notification} />)}
          {user ? (
            <img
              className={styles.profileImg}
              src={getProfilePic(user?.photo)}
            />
          ) : (
            <i className="fonticons fonticons-user" />
          )}

          <span>Perfil</span>
        </Link>
      </div>

      <ClickAwayListener
        onClickAway={(e: any) => {
          if (e.composedPath?.().includes(centralLogoRef.current)) return;
          setShowMenu(false);
        }}
      >
        <div className={clsx(styles.menuContainer, showMenu && styles.opened)}>
          <a href="/">Inicio</a>
          <a href="/pricing">Precios</a>
          <a href="/companyTerms">Términos y condiciones</a>
          <a href="/cookies-politics">Política de Privacidad</a>
        </div>
      </ClickAwayListener>
    </footer>
  );
}
